import { render, staticRenderFns } from "./DoctorPhoto.vue?vue&type=template&id=2cb9ed2c&"
import script from "./DoctorPhoto.vue?vue&type=script&lang=js&"
export * from "./DoctorPhoto.vue?vue&type=script&lang=js&"
import style0 from "./DoctorPhoto.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports